import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENV_CONFIG, EnvironmentConfig } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { GpsTrackPointView } from 'src/app/data/model/gps-tracking-view';

import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule,
})
export class GpsTrackingStartStopApiService extends CrudApiService<GpsTrackPointView> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('data/telemetries/gps-start-stop', http, config);
  }
}
